import useGetPosts from '../../../hooks/ai-forums/useGetPosts';
import ForumPost from './ForumPost';
import { css } from '@compiled/react';
import { MOBILE } from '../../../utils/constants';
import { token } from '@atlaskit/tokens';

export const PostsFeed = ({ selectedCategory }: { selectedCategory: string }) => {
  // const { normalizedPosts, pageInfo, totalCount, results } = useGetPosts({ // optional values
  const { normalizedPosts } = useGetPosts({
    categoryId: selectedCategory || undefined,
    first: 20, // Default to 20 posts per page
    sortOrders: [{ field: 'CREATED_AT', direction: 'DESC' }], // Show newest posts first
  });

  return (
    <div data-testid="forum-posts-list" css={postsListStyles}>
      {normalizedPosts.length > 0 ? (
        normalizedPosts.map((post) => <ForumPost key={post.id} post={post} />)
      ) : (
        <div css={noPostsStyle}>
          <p>No posts found for this category.</p>
        </div>
      )}
    </div>
  );
};

const postsListStyles = css({
  [MOBILE.MEDIA_QUERY]: {
    marginTop: '16px',
  },
});

const noPostsStyle = css({
  textAlign: 'center',
  padding: '40px 20px',
  color: token('color.text.subtle'),
  fontSize: '16px',
});
